export const colorsReducer = (state = {  }, action) => {
    switch(action.type){
        case 'GET_COLORS_CARDS_PENDING':
            return { loading: true } 
        case 'GET_COLORS_CARDS_SUCCESS':
            return { loading: false, colors: action.payload }
        case 'GET_COLORS_CARDS_FAILED':
            return {loading:false, error: action.payload}
        default:
            return state
    }

}